import { DEFAULT_EVENT_DURATION_MINUTES } from './event-flow-constants';

type EventTiming = Readonly<{
  ends_at?: string | null;
  registration_closes_at?: string | null;
  starts_at: string;
}>;

export function effectiveEventEnd(event: EventTiming): Date {
  if (event.ends_at) {
    return new Date(event.ends_at);
  }

  return new Date(new Date(event.starts_at).getTime() + DEFAULT_EVENT_DURATION_MINUTES * 60 * 1000);
}

export function effectiveRegistrationClosesAt(event: EventTiming): Date {
  if (event.registration_closes_at) {
    return new Date(event.registration_closes_at);
  }

  return effectiveEventEnd(event);
}

export function hasEventEnded(event: EventTiming, now: Date): boolean {
  return now >= effectiveEventEnd(event);
}

export function isEventUnderway(event: EventTiming, now: Date): boolean {
  return now >= new Date(event.starts_at) && !hasEventEnded(event, now);
}

export function isEventRegistrationOpen(event: EventTiming, now: Date): boolean {
  return !hasEventEnded(event, now) && now < effectiveRegistrationClosesAt(event);
}
